<div
  id="pu-floating-button__component"
  class="wrapper"
  (click)="openOverlay()"
>
  <pu-support-circle-image />

  <div
    class="overlay"
    [class.overlay-opened]="overlayOpened"
  >
    @for (action of actions(); track action.type) {
      @switch (action.type) {
        @case (actionType.PlatformSupport) {
          @if (action.isDisabled) {
            <ng-container
              *ngTemplateOutlet="comingSoonAction; context: { type: platformSupport, isDisabled: action.isDisabled }"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="platformSupport"></ng-container>
          }
        }

        @case (actionType.ItSupport) {
          @if (action.isDisabled) {
            <ng-container
              *ngTemplateOutlet="comingSoonAction; context: { type: itSupport, isDisabled: action.isDisabled }"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="itSupport"></ng-container>
          }
        }

        @case (actionType.FinanceSupport) {
          @if (action.isDisabled) {
            <ng-container
              *ngTemplateOutlet="comingSoonAction; context: { type: financeSupport, isDisabled: action.isDisabled }"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="financeSupport"></ng-container>
          }
        }

        @case (actionType.OfficeSupport) {
          @if (action.isDisabled) {
            <ng-container
              *ngTemplateOutlet="comingSoonAction; context: { type: officeSupport, isDisabled: action.isDisabled }"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="officeSupport"></ng-container>
          }
        }

        @case (actionType.EducationSupport) {
          @if (action.isDisabled) {
            <ng-container
              *ngTemplateOutlet="comingSoonAction; context: { type: educationSupport, isDisabled: action.isDisabled }"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="educationSupport"></ng-container>
          }
        }

        @case (actionType.AiChat) {
          @if (action.isDisabled) {
            <ng-container
              *ngTemplateOutlet="comingSoonAction; context: { type: aiChat, isDisabled: action.isDisabled }"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="aiChat"></ng-container>
          }
        }
      }
    }
  </div>
</div>

<ng-template #comingSoonAction let-template="type" let-isDisabled="isDisabled">
  <div class="overlay-item disabled">
    <ng-container
      *ngTemplateOutlet="template; context: { $implicit: isDisabled }">
    </ng-container>
    <div class="soon">{{ 'buttons.soon' | translateIn }}</div>
  </div>
</ng-template>

<ng-template #platformSupport let-isDisabled>
  <button
    type="button"
    puButton
    uiType="gradient"
    size="m"
    [class]="isDisabled ? '' : 'overlay-item'"
    [disabled]="isDisabled"
    (click)="openSupport(categories.platform)"
  >
    <pu-icon iconName="platform" size="20" />

    <p>{{ 'platformSupportText' | translateIn }}</p>
  </button>
</ng-template>

<ng-template #itSupport let-isDisabled>
  <button
    type="button"
    puButton
    uiType="gradient"
    size="m"
    [class]="isDisabled ? '' : 'overlay-item'"
    [disabled]="isDisabled"
    (click)="openITSupportDialog()"
  >
    <pu-icon iconName="display" size="20" />

    <p>{{ 'buttons.itSupport' | translateIn }}</p>
  </button>
</ng-template>

<ng-template #financeSupport let-isDisabled>
  <button
    type="button"
    puButton
    uiType="gradient"
    size="m"
    [class]="isDisabled ? '' : 'overlay-item'"
    [disabled]="isDisabled"
    (click)="openFinanceDialog()"
  >
    <pu-icon iconName="finance" size="20" />

    <p>{{ 'buttons.finance' | translateIn }}</p>
  </button>
</ng-template>

<ng-template #officeSupport let-isDisabled>
  <button
    type="button"
    puButton
    uiType="gradient"
    size="m"
    [class]="isDisabled ? '' : 'overlay-item'"
    [disabled]="isDisabled"
    (click)="openSupport(categories.office)"
  >
    <pu-icon iconName="office" size="20" />

    <p>{{ 'buttons.office' | translateIn }}</p>
  </button>
</ng-template>

<ng-template #educationSupport let-isDisabled>
  <button
    type="button"
    puButton
    uiType="gradient"
    size="m"
    [class]="isDisabled ? '' : 'overlay-item'"
    [disabled]="isDisabled"
    (click)="openSupport(categories.education)"
  >
    <pu-icon iconName="education" size="20" />

    <p>{{ 'buttons.education' | translateIn }}</p>
  </button>
</ng-template>

<ng-template #aiChat let-isDisabled>
  <button
    id="pt-floating-button__ai-chat"
    type="button"
    puButton
    uiType="gradient"
    size="m"
    [class]="isDisabled ? '' : 'overlay-item'"
    [disabled]="isDisabled"
    (click)="openAiChat()"
  >
    <pu-icon [iconName]="aiChatButtonIcon" size="20" />

    <p>{{ 'buttons.aiChat' | translateIn }}</p>
  </button>
</ng-template>
